import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { AtividadeGrupoDBService } from '../database/atividade-grupo-db.service';

@Injectable({
    providedIn: 'root'
})
export class AtividadeGrupoService extends BaseService {
    override classname = 'AtividadeGrupoService';
    override route = 'atividade-grupo';
    override database = new AtividadeGrupoDBService();
}
